"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = _interopRequireDefault(require("./colors"));
var _inverseColors = _interopRequireDefault(require("./inverseColors"));
var _border = _interopRequireDefault(require("./border"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var formFields = {
  backgroundColor: _colors["default"].monochrome1["default"],
  color: _colors["default"].monochrome5["default"],
  border: {
    radius: _border["default"].radius[2],
    width: _border["default"].width[1],
    color: _colors["default"].monochrome4["default"],
    style: _border["default"].style[1]
  },
  icon: {
    appearance: 'primary',
    inverse: false
  },
  state: {
    success: {
      color: _colors["default"].monochrome5["default"],
      backgroundColor: _colors["default"].monochrome1["default"],
      border: {
        color: _colors["default"].success["default"],
        width: _border["default"].width[2],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    },
    info: {
      color: _colors["default"].monochrome5["default"],
      backgroundColor: _colors["default"].monochrome1["default"],
      border: {
        color: _colors["default"].info["default"],
        width: _border["default"].width[2],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    },
    warn: {
      color: _colors["default"].monochrome5["default"],
      backgroundColor: _colors["default"].monochrome1["default"],
      border: {
        color: _colors["default"].warn["default"],
        width: _border["default"].width[2],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    },
    error: {
      color: _colors["default"].monochrome5["default"],
      backgroundColor: _colors["default"].monochrome1["default"],
      border: {
        color: _colors["default"].error["default"],
        width: _border["default"].width[2],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    },
    disabled: {
      color: _colors["default"].monochrome5.disabled,
      backgroundColor: _colors["default"].monochrome2["default"],
      border: {
        color: _colors["default"].monochrome5.disabled,
        width: _border["default"].width[1],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    }
  },
  selected: {
    backgroundColor: _colors["default"].secondary1["default"],
    color: _colors["default"].monochrome1["default"],
    border: {
      color: _colors["default"].secondary1["default"],
      width: _border["default"].width[1],
      radius: _border["default"].radius[2],
      style: _border["default"].style[1]
    }
  },
  inverse: {
    backgroundColor: _inverseColors["default"].monochrome1["default"],
    color: _inverseColors["default"].monochrome5["default"],
    border: {
      radius: _border["default"].radius[2],
      width: _border["default"].width[1],
      color: _inverseColors["default"].monochrome3["default"],
      style: _border["default"].style[1]
    },
    icon: {
      appearance: 'primary',
      inverse: false
    },
    state: {
      success: {
        color: _inverseColors["default"].monochrome5["default"],
        backgroundColor: _inverseColors["default"].monochrome1["default"],
        border: {
          color: _inverseColors["default"].success["default"],
          width: _border["default"].width[2],
          radius: _border["default"].radius[2],
          style: _border["default"].style[1]
        }
      },
      info: {
        color: _inverseColors["default"].monochrome5["default"],
        backgroundColor: _inverseColors["default"].monochrome1["default"],
        border: {
          color: _inverseColors["default"].info["default"],
          width: _border["default"].width[2],
          radius: _border["default"].radius[2],
          style: _border["default"].style[1]
        }
      },
      warn: {
        color: _inverseColors["default"].monochrome5["default"],
        backgroundColor: _inverseColors["default"].monochrome1["default"],
        border: {
          color: _inverseColors["default"].warn["default"],
          width: _border["default"].width[2],
          radius: _border["default"].radius[2],
          style: _border["default"].style[1]
        }
      },
      error: {
        color: _inverseColors["default"].monochrome5["default"],
        backgroundColor: _inverseColors["default"].monochrome1["default"],
        border: {
          color: _inverseColors["default"].error["default"],
          width: _border["default"].width[2],
          radius: _border["default"].radius[2],
          style: _border["default"].style[1]
        }
      },
      disabled: {
        color: _inverseColors["default"].monochrome5.disabled,
        backgroundColor: _inverseColors["default"].monochrome2["default"],
        border: {
          color: _inverseColors["default"].monochrome5.disabled,
          width: _border["default"].width[1],
          radius: _border["default"].radius[2],
          style: _border["default"].style[1]
        }
      }
    },
    selected: {
      backgroundColor: _inverseColors["default"].secondary1["default"],
      color: _inverseColors["default"].monochrome6["default"],
      border: {
        color: _inverseColors["default"].secondary1["default"],
        width: _border["default"].width[1],
        radius: _border["default"].radius[2],
        style: _border["default"].style[1]
      }
    }
  }
};
var _default = formFields;
exports["default"] = _default;